export const FOOTER_BLOCK_s3 = {
  "blockType": "FOOTER",
  "blockDesign": "FooterDesign1",
  "editFormName": "FOOTER_FORM_1",
  "styleProps": {
    "background-color": "#0F0F0F",
    "padding": "80px 20px 80px 20px"
  },
  "logo": {
    "text": "✦ Predic",
    "href": "#",
    "styleProps": {
      "color": "#ffffff",
      "font-family-bk": "'Lato', sans-serif",
      "font-family": "'Lato', sans-serif",
      "font-size": "1.5rem",
      "line-height": "2rem",
      "padding": "0px 0px 0px 0px"
    }
  },
  "description": {
    "list": [
      "Transforming Businesses with Innovative Software Solutions"
    ],
    "styleProps": {
      "color": "#ffffff",
      "font-size": "1.125rem",
      "line-height": "1.75rem",
      "max-width": "320px",
      "margin": "0px 0px 120px 0px"
    }
  },
  "copy": {
    "text": "© Copyright 2022 FlexBee. All Rights Reserved.",
    "href": "#",
    "styleProps": {
      "color": "#808080",
      "margin": "0px 0px 0px 0px"
    }
  },
  "terms": {
    "text": "Terms",
    "href": "#",
    "styleProps": {
      "color": "#808080",
      "font-size": "1rem",
      "line-height": "1.5rem"
    }
  },
  "privacy": {
    "text": "Privacy",
    "href": "#",
    "styleProps": {
      "color": "#808080",
      "font-size": "1rem",
      "line-height": "1.5rem"
    }
  },
  "metaDataId": 1746350699849,
  "afterIndex": 25,
  "blockId": 1746350699849,
  "stylePropsTab": {
    "padding": "60px 20px 60px 20px"
  },
  "stylePropsMob": {
    "padding": "40px 20px 40px 20px"
  }
}